import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

export interface SponsorshipIconProps {
  photoUrl?: string;
}
export const SponsorshipIcon: React.FC<SponsorshipIconProps> = ({
  photoUrl,
}) => {
  if (!photoUrl) {
    return <ArkIcon iconName="child" />;
  }
  return (
    <img
      height="100%"
      width="100%"
      draggable={false}
      src={photoUrl}
      alt="Participant"
      className="object-fit-cover object-position-top rounded-full"
    />
  );
};
